import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Wrapper from 'components/Wrapper';
import routesPath from 'config/routesPath';
import { Creators as UserCreators } from 'modules/resale/store/ducks/user';
import { checkCallCenterOsSearchAndRescueRoute } from 'helpers/checkCallcenterOrSearchAndRescue';

import { useCheckMeAccess } from './services/queries';
import accessUnavaliableAnimationfrom from './assets/access-unavaliable-animation.json';

import * as S from './styles';

const DEFAULT_OPTIONS_LOTTIE = {
  loop: true,
  autoplay: true,
  animationData: accessUnavaliableAnimationfrom,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

const intervalTime = 300000;

export const AccessUnavaliable = ({ children }) => {
  const dispatch = useDispatch();
  const { currentDealer } = useSelector(state => state.dealerStore);
  const { restrictAccess } = useSelector(state => state.userStore);

  const location = useLocation();

  const { data, refetch } = useCheckMeAccess({ dealerId: currentDealer.id });

  const checkCurrentUserAccess = async () => {
    try {
      refetch();
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  useEffect(() => {
    let intervalId = null;

    if (currentDealer.id) {
      checkCurrentUserAccess();
      intervalId = setInterval(() => checkCurrentUserAccess(), intervalTime);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [currentDealer.id]);

  useEffect(() => {
    if (data?.hasOwnProperty('restrictedAccess')) {
      dispatch(UserCreators.setUserRestrictAccess(data?.restrictedAccess));
    }
  }, [data]);

  const myResellersRoute = location.pathname === routesPath.myResellers;

  if (
    !checkCallCenterOsSearchAndRescueRoute() &&
    !myResellersRoute &&
    restrictAccess
  ) {
    return (
      <S.Container>
        <Lottie
          options={DEFAULT_OPTIONS_LOTTIE}
          height={300}
          width={300}
          speed={1}
          isStopped={false}
          isPaused={false}
          direction={1}
        />
        <Wrapper flex align="center" direction="column" alignSelf="center">
          <S.Title>Ops! Acesso indisponível</S.Title>
          <S.SubTitle>
            Parece que seu usuário está inativo para essa loja ou você está fora
            horário de trabalho. Caso considere essa situação incorreta, por
            favor, entre em contato com o nosso canal de atendimento.
          </S.SubTitle>
        </Wrapper>
      </S.Container>
    );
  }

  return children;
};
